/* eslint-disable ember/no-mixins */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import ReportingBaseMixin from 'linced-app/mixins/reporting-base';

export default class ViewController extends Controller.extend(
  ReportingBaseMixin,
) {
  @service
  router;

  // Declared so the param binds reliably rather than relying on the
  // route's queryParams hash alone.
  queryParams = ['periodIndex', 'periodEndDate', 'periodYear'];
  @tracked periodIndex = null;
  // The period's end date, which addresses it across template versions where
  // an index cannot. Set by the group cards; absent for an orphaned period.
  @tracked periodEndDate = null;
  // The academic year the period belongs to. Set by historic cards, which can
  // sit in a past year; absent means the current one.
  @tracked periodYear = null;

  @alias('groupController.activeReport')
  activeReport;

  // "group - template - year - period" header line, built by the route so it
  // names the period actually being viewed. Separate from the template
  // record's displayName, which is shared with screens that aren't
  // group-scoped.
  @tracked viewHeading = null;

  // Group-view state
  @tracked viewStudents = null;

  @tracked viewStudentReports = null;

  // Each report is rendered against its own template version, keyed by
  // studentId (published reports can sit on older versions of the chain).
  @tracked viewStudentTemplates = null;

  @tracked
  viewSelectedStudent = null;

  // Every published report as an array — drives the group "Download All"
  // button (BulkPdfDownload resolves each report's own template version).
  @computed('viewStudents.[]', 'viewStudentReports')
  get viewAllStudentReports() {
    let students = this.viewStudents || [];
    let reportMap = this.viewStudentReports || {};
    return students.map((s) => reportMap[s.get('id')]).filter(Boolean);
  }

  cleanupViewView() {
    this.viewHeading = null;
    this.viewStudents = null;
    this.viewStudentReports = null;
    this.viewStudentTemplates = null;
    this.viewSelectedStudent = null;
  }

  @action
  exitView() {
    let groupCtrl = this.groupController;
    this.cleanupViewView();
    groupCtrl.set('activeReport', null);
    this.router.transitionTo('reporting.group');
  }

  @action
  selectViewStudent(student) {
    this.viewSelectedStudent = student;
  }
}
